"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
exports.Link = react_1.default.forwardRef((props, ref) => {
    const { id, children, copy, href, openInNewTab, onClick, 'aria-label': ariaLabel } = props, rest = __rest(props, ["id", "children", "copy", "href", "openInNewTab", "onClick", 'aria-label']);
    const target = openInNewTab ? '_blank' : undefined;
    return (react_1.default.createElement(styles_1.StyledLink, Object.assign({ ref: ref, id: id, href: href, target: target, "aria-label": ariaLabel, onClick: onClick }, rest),
        copy,
        children));
});
